import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "clearButton"]
  static values = {
    searchUrl: String
  }

  connect() {
    this.timeout = null
    this.updateClearButton()
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  search() {
    if (this.timeout) clearTimeout(this.timeout)

    this.timeout = setTimeout(() => this.fetchResults(), 200)
  }

  async fetchResults() {
    const query = this.inputTarget.value.trim()
    if (query.length < 2) {
      this.clearResults()
      return
    }

    const url = new URL(this.searchUrlValue, window.location.origin)
    url.searchParams.set("q", query)

    const response = await fetch(url, { headers: { Accept: "application/json" } })
    const medicines = await response.json()
    this.renderResults(Array.isArray(medicines) ? medicines : [])
  }

  add(event) {
    event.preventDefault()

    const { id, name } = event.currentTarget.dataset
    const url = new URL(window.location.href)
    const ids = url.searchParams.getAll("medicine_ids[]")

    if (!ids.includes(id)) url.searchParams.append("medicine_ids[]", id)
    url.searchParams.set("tab", "price")

    this.inputTarget.value = name
    this.clearResults()
    window.location.href = url.toString()
  }

  remove(event) {
    event.preventDefault()

    const id = event.currentTarget.dataset.id
    const url = new URL(window.location.href)
    const remaining = url.searchParams.getAll("medicine_ids[]").filter((value) => value !== id)

    this.deleteParamVariants(url, "medicine_ids")
    remaining.forEach((value) => url.searchParams.append("medicine_ids[]", value))
    url.searchParams.set("tab", "price")

    window.location.href = url.toString()
  }

  clearAll(event) {
    event.preventDefault()

    const url = new URL(window.location.href)
    this.deleteParamVariants(url, "medicine_ids")
    url.searchParams.set("tab", "price")

    window.location.href = url.toString()
  }

  deleteParamVariants(url, baseName) {
    url.searchParams.delete(baseName)
    url.searchParams.delete(`${baseName}[]`)
  }

  updateClearButton() {
    if (!this.hasClearButtonTarget) return

    const params = new URL(window.location.href).searchParams
    const hasSelectedMedicines = params.has("medicine_ids") || params.has("medicine_ids[]")
    this.clearButtonTarget.classList.toggle("hidden", !hasSelectedMedicines)
  }

  renderResults(medicines) {
    if (medicines.length === 0) {
      this.resultsTarget.innerHTML = '<div class="px-3 py-2 text-sm text-gray-500">No se encontraron medicamentos</div>'
      this.resultsTarget.classList.remove("hidden")
      return
    }

    this.resultsTarget.innerHTML = medicines.map((medicine) => `
      <button type="button"
              class="block w-full px-3 py-2 text-left text-sm text-gray-700 hover:bg-brand-primary-subtle"
              data-action="medicine-selector#add"
              data-id="${medicine.id}"
              data-name="${this.escapeHtml(medicine.name)}">
        ${this.escapeHtml(medicine.name)}
      </button>
    `).join("")
    this.resultsTarget.classList.remove("hidden")
  }

  clearResults() {
    this.resultsTarget.innerHTML = ""
    this.resultsTarget.classList.add("hidden")
  }

  escapeHtml(value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;")
  }
}
